import { createRequest, platform, Data, AdditionalParams } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { Trip, TripSortKeys } from "./types"
import { fromApi } from "./utils"
import { isNewPipelinePolicy } from "../../../utils"

type FindVehicleTripsInputBase = Readonly<{
  policyId: string
  startedAtAfter?: string
  startedAtBefore?: string
  vrn: string
}>
export type FindVehicleTripsInput = FindVehicleTripsInputBase & AdditionalParams<TripSortKeys>
type Output = Data<Trip>

const findVehicleTrips = createRequest<FindVehicleTripsInputBase, Output>(
  async (input: FindVehicleTripsInputBase, getToken): Promise<Output> => {
    const api = platform(getToken)
    const useNewPipeline = isNewPipelinePolicy(input.policyId)
    const result = await api.trips.vehicleTrips({
      ...input,
      ...(useNewPipeline ? { dbName: `athena` } : {}),
    })

    return {
      ...result,
      items: result.items.map((it) => fromApi(it)),
    }
  }
)

export const useFindVehicleTrips = createRequestHook<FindVehicleTripsInputBase, Output, TripSortKeys>(findVehicleTrips)
